import React, {useEffect, useRef} from 'react';

import {useInfiniteNewsList} from 'hooks/useQuery/news/useInfiniteNewsList';
import {ContentListItem} from './parts/contentListItem';

import styles from './styles.module.scss';

export const NewsList = () => {
    const loadMoreRef = useRef(null);
    const { news, error, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } = useInfiniteNewsList();
    const newsItems = Array.isArray(news) ? news : [];

    useEffect(() => {
        if (!loadMoreRef.current || !hasNextPage || isFetchingNextPage) {
            return undefined;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0] && entries[0].isIntersecting) {
                    fetchNextPage();
                }
            },
            {
                rootMargin: '300px 0px'
            }
        );

        observer.observe(loadMoreRef.current);

        return () => {
            observer.disconnect();
        };
    }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

    return (
        <div className={styles.contentWrapper}>
            {isLoading ? <div className={styles.status}>Загрузка новостей...</div> : null}

            {!isLoading && error ? <div className={styles.error}>Ошибка загрузки новостей</div> : null}

            {!error && !isLoading && !newsItems.length ? (
                <div className={styles.emptyState}>Нет новостей для отображения</div>
            ) : null}

            {!error && !isLoading && newsItems.length ? (
                <div className={styles.contentListWrapper}>
                    {newsItems.map((item, index) => (
                        <ContentListItem key={item && item._id ? item._id : index} content={item} />
                    ))}
                </div>
            ) : null}

            <div ref={loadMoreRef} className={styles.loadMoreTrigger} />

            {isFetchingNextPage ? <div className={styles.status}>Подгружаем ещё новости...</div> : null}
        </div>
    );
};
